import createHistory from 'history/createBrowserHistory';
import createHashHistory from 'history/createHashHistory';

// A singleton history object for easy API navigation
const history = createHashHistory();
export default history;



// WEBPACK FOOTER //
// ./src/common/history.js